import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from 'react-redux';
import { DownloadFileAPI, UploadFileAPI } from '../../services';
import { Toastify, mimeTypes } from '../utils';
import { config } from '../../services/config';

const MyEditor = ({ onSubmit, onCommentChange, initialContent }) => 
{
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const [editorContent, setEditorContent] = useState(initialContent);
	useEffect(() =>
	{
		setEditorContent(initialContent);
	}, [initialContent]);
  
	const EditorChange = (e, editor) =>
	{
		if (onCommentChange)
		{
			const newContent = editor.getContent();

			setEditorContent(newContent);
			onCommentChange(newContent);
		}
	};

	const EditorSubmit = (e) =>
	{
		if (onSubmit)
		{
			onSubmit();
		}
	};

	const UploadFile = async (file, callback) =>
	{
		try
		{
			let formData = new FormData();
			formData.append('file', file);
			formData.append("directory", "comment_attachments");
			const APIResponse = await UploadFileAPI(formData);
			if(APIResponse && typeof APIResponse === "object")
			{
				if(APIResponse.result)
				{
					if(!APIResponse.location.includes('http'))
					{
						APIResponse.location = config.CRM+'/'+APIResponse.location;
					}
					callback(APIResponse.location, {text: language.ATTACHMENT});
				}
				else if(APIResponse.message !== "")
				{
					Toastify(APIResponse.message);
				}
			}
		}
		catch (ex){}
	}
  
	const FilePicker = (callback, value, meta) =>
	{
		let acceptableFiles = (meta.filetype === 'file') ? '.xlsx, .xls, .csv, .doc, .docx, .txt, .pdf, .ppt, .pptx, .json, .rar, .zip' : 'image/*';
		let input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', acceptableFiles);
		input.onchange = (e) =>
		{
			if(meta.filetype === 'image' && !e.target.files[0].type.includes('image'))
			{
				Toastify(language.ERROR.INVALID_FILE_FORMAT);
				return false;
			}
			else
			{
				UploadFile(e.target.files[0], callback);
			}
		}
		input.click();
	};

	const editorRef = useRef(null);

	return (
		<div>
			<Editor
				tinymceScriptSrc={`/tinymce/tinymce.min.js`}
				apiKey='ibdbvqq53kc9tkk58q7pjp8tfl7alvuej15h0vy8ydnvsrcg'
				onInit={(evt, editor) => { editorRef.current = editor }}
				init={{
					directionality: 'rtl',
					height: 300,
					width: '100%',
					plugins: 'image lists link autolink emoticons table',
					toolbar: 'image link emoticons | bold italic strikethrough | alignright aligncenter alignleft | backcolor forecolor | fontsize |bullist table hr| redo undo',
					branding: false,
					menubar: false,
					contextmenu: false,
					language: 'fa',
					font_size_formats: '8pt 10pt 12pt',
					content_style: `body { font-size:10pt; } .tox-tinymce { direction:rtl }`, 
					file_picker_types: 'file image',
					mobile: {'menubar': true},
					skin_url: `/tinymce/skins/ui/oxide`,
					content_css: `/tinymce/skins/content/default/content.min.css`,
					file_picker_callback: FilePicker,
					setup: (editor) =>
					{
						editor.on("NodeChange", (e) =>
						{
							if(e && e.element.nodeName.toLowerCase() === "img")
							{
								if(e.element.src.indexOf('entryPoint=download&id=') !== -1)
								{
									const fileID = e.element.src.split('entryPoint=download&id=')[1];
									const fileURL = e.element.src;
									DownloadFileAPI(fileID).then(APIResponse =>
									{
										let extension = '';
										if(APIResponse.extension)
										{
											extension = APIResponse.extension;
										}
										else if(APIResponse.name && APIResponse.name.indexOf('.') > -1)
										{
											extension = APIResponse.name.split('.').slice(-1)[0];
										}
										const mime = mimeTypes[extension];
										let fileSRC = APIResponse.url;
										if(typeof mime !== 'undefined' && mime.includes('image') && APIResponse.content.length)
										{
											fileSRC = 'data:'+mime+';base64,'+APIResponse.content;
										}
										editorRef.current?.dom.setAttribs(e.element, {'data-location': fileURL, width:"auto", height:"100px", style:"border-radius:7px", src: fileSRC});
									});
								}
							}
						});
					}
				}}
				onEditorChange={EditorChange}
				value={editorContent}
			/>
			<button className="btn-primary" onClick={EditorSubmit}>{language["SUBMIT_COMMENT"]}</button>
		</div>
	);
};

export default MyEditor;